import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f30a3da"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { id: "summary-page-title" }, "Summary", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "summary-page-block" }
const _hoisted_4 = { class: "summary-box" }
const _hoisted_5 = { class: "summary-box-title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Property Address", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "summary-information" }
const _hoisted_10 = { class: "summary-box" }
const _hoisted_11 = { class: "summary-box-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Energy Details", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "summary-information" }
const _hoisted_16 = {
  key: 0,
  class: "summary-box"
}
const _hoisted_17 = { class: "summary-box-title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tenant Details", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "summary-information" }
const _hoisted_22 = { class: "summary-page-block" }
const _hoisted_23 = {
  key: 0,
  class: "summary-box"
}
const _hoisted_24 = { class: "summary-box-title" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Landlord Details", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "summary-information" }
const _hoisted_29 = {
  key: 1,
  class: "summary-box"
}
const _hoisted_30 = { class: "summary-box-title" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "TCF", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "summary-information" }
const _hoisted_35 = {
  key: 2,
  class: "summary-box"
}
const _hoisted_36 = { class: "summary-box-title" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Billing Details", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-edit" }, null, -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "summary-information" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }

import { PropType, computed, onMounted, ref } from "vue";
import { PersonalInfo } from "@/types/switches/PersonalInfo";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { Address } from "@/types/generic/Address";
import scrollView from "@/components/ui/scroll-view.vue";
import { SwitchBillTo } from "@/enums/utility-switching/SwitchBillTo";
import { SwitchPage } from "@/enums/utility-switching/SwitchPage";
import { useAgencyAccountStore } from "@/stores/utility-switching/AgencyAccountStore";
import { AgencyAccount } from "@/types/switches/AgencyAccount";
import { getErrorMessage } from "bright-logic-core/src/errors";


export default /*#__PURE__*/_defineComponent({
  __name: 'summary-page',
  props: {
  /**
   * The selected address for energy-related purposes.
   * @type {Address}
   * @required
   */
  energySelectedAddress: {
    type: Object as PropType<Address>,
    required: true,
  },

  /**
   * The personal information of the landlord.
   * @type {LandlordPersonalInfo}
   */
  landlordPersonalInfo: {
    type: Object as PropType<LandlordPersonalInfo>,
  },

  /**
   * The personal information of the tenant.
   * @type {PersonalInfo}
   */
  tenantPersonalInfo: {
    type: Object as PropType<PersonalInfo>,
  },

  /**
   * The type of energy associated with the property.
   * @type {string}
   * @required
   */
  energyType: {
    type: String,
    required: true,
  },

  /**
   * Indicates whether the TCF (Third-Party Consent Form) has been uploaded.
   * @type {boolean}
   * @default false
   */
  tcfUploaded: {
    type: Boolean,
    default: false,
  },

  /**
   * Indicates whether to display the TCF in the UI.
   * @type {boolean}
   * @required
   */
  displayTcf: {
    type: Boolean,
    required: true,
  },

  /**
   * Indicates whether to display the billing address.
   * @type {boolean}
   * @default false
   */
  displayBillingAddress: {
    type: Boolean,
    default: false,
  },

  /**
   * Indicates whether to bill the landlord.
   * @type {boolean}
   * @default false
   */
  billToLandlord: {
    type: Boolean,
    default: false,
  },

  /**
   * The identifier for billing information.
   * @type {number}
   * @default -1
   */
  billingInformation: {
    type: Number,
    default: -1,
  },

  /**
   * Indicates whether to disable the edit buttons.
   * @type {boolean}
   * @default false
   */
  disableEditButtons: {
    type: Boolean,
    default: false,
  },
},
  emits: ["updatePageNumber"],
  setup(__props, { emit }) {

const props = __props;





const editDetails = (page: string) => {
  if (props.disableEditButtons) {
    return;
  }

  emit("updatePageNumber", page);
};

const screeWidth = ref(screen.width);

const smallScreen = computed(() => screeWidth.value < 875);

const billToText = computed(() => {
  switch (props.billingInformation) {
    case SwitchBillTo.Landlord:
      return "Landlord";
    case SwitchBillTo.LandlordCOAgency:
      return `CO ${props.landlordPersonalInfo?.firstName} ${props.landlordPersonalInfo?.lastName}`;
    default:
      return "Landlord";
  }
});

const agencyAccountStore = useAgencyAccountStore();
const agencyAccount = ref<AgencyAccount>();

onMounted(async () => {
  try {
    agencyAccount.value = await agencyAccountStore.getAccount();
  } catch (err) {
    console.error(getErrorMessage(err));
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("section", {
        class: _normalizeClass(["summary-page", { smallScreen: smallScreen.value }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("section", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (editDetails(_unref(SwitchPage).PropertyPage))),
                class: "icon"
              }, _hoisted_8)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.propertyName), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.street), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.locality), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.town), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.region), 1),
                _createElementVNode("li", null, _toDisplayString(__props.energySelectedAddress.postCode), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editDetails(_unref(SwitchPage).EnergyPage))),
                class: "icon"
              }, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(props.energyType), 1)
              ])
            ])
          ]),
          (props.tenantPersonalInfo)
            ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (editDetails(_unref(SwitchPage).TenantPage))),
                    class: "icon"
                  }, _hoisted_20)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(props.tenantPersonalInfo.firstName) + " " + _toDisplayString(props.tenantPersonalInfo.lastName), 1),
                    _createElementVNode("li", null, _toDisplayString(props.tenantPersonalInfo.number), 1),
                    _createElementVNode("li", null, _toDisplayString(props.tenantPersonalInfo.email), 1),
                    _createElementVNode("li", null, " Tenancy Start Date: " + _toDisplayString(new Date(
                    props.tenantPersonalInfo.tenancyStartDate,
                  ).toLocaleDateString("en-gb")), 1),
                    _createElementVNode("li", null, " Critical Care: " + _toDisplayString(props.tenantPersonalInfo.priorityService ? "Yes" : "No"), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          (props.landlordPersonalInfo)
            ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (editDetails(_unref(SwitchPage).LandlordPage))),
                    class: "icon"
                  }, _hoisted_27)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.firstName) + " " + _toDisplayString(props.landlordPersonalInfo.lastName), 1),
                    _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.number), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (props.displayTcf)
            ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (editDetails(_unref(SwitchPage).TcfPage))),
                    class: "icon"
                  }, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, "TCF Added: " + _toDisplayString(props.tcfUploaded ? "Yes" : "No"), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (props.displayBillingAddress && props.landlordPersonalInfo)
            ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("span", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (editDetails(_unref(SwitchPage).BillingPage))),
                    class: "icon"
                  }, _hoisted_39)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", null, "To be Billed: " + _toDisplayString(billToText.value), 1),
                  (props.billingInformation === _unref(SwitchBillTo).Landlord)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.propertyName), 1),
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.street), 1),
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.locality), 1),
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.town), 1),
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.region), 1),
                        _createElementVNode("li", null, _toDisplayString(props.landlordPersonalInfo.address.postCode), 1)
                      ]))
                    : (agencyAccount.value)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_42, [
                          _createElementVNode("li", null, _toDisplayString(agencyAccount.value.address.street), 1),
                          _createElementVNode("li", null, _toDisplayString(agencyAccount.value.address.city), 1),
                          _createElementVNode("li", null, _toDisplayString(agencyAccount.value.address.county), 1),
                          _createElementVNode("li", null, _toDisplayString(agencyAccount.value.address.postalCode), 1)
                        ]))
                      : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})